import React from 'react';
import Ratio from 'react-ratio';
import images from '../../assets';

import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Store from 'store';
import {
  ContentsWrap,
  VerticalSp,
  HorizontalSp,
  RowCenter,
  HSLine,
  RowColum,
  ContentsArea,
  ModalContents,
  ModalTitle,
  MediaQuery,
  ModalNorBtn,
} from '../Common';
import { Fade, Modal } from '@material-ui/core';
import { isMobile } from 'react-device-detect';

export const GroupItem = ({ active = false, onClick, fontSize = 18, children }) => {
  return (
    <>
      <VerticalSp sp={22} />
      <div onClick={onClick} style={{ display: 'flex', alignItems: 'center', height: 38, cursor: 'pointer' }}>
        <div style={{ width: 17, display: 'flex', alignItems: 'center' }}>
          <div style={{ width: 6, height: 6, borderRadius: 10, backgroundColor: active ? '#ff8a06' : 'white' }} />
        </div>
        <div style={{ fontFamily: 'NSCJKrB', fontSize: fontSize, fontWeight: 'bold', color: active ? '#ff8a06' : 'black' }}>{children}</div>
      </div>
    </>
  );
};

export const GroupItemDouble = ({ active = false, onClick, fontSize = 18, children }) => {
  return (
    <>
      <VerticalSp sp={22} />
      <div onClick={onClick} style={{ display: 'flex', alignItems: 'center', height: 65, cursor: 'pointer' }}>
        <div style={{ width: 17, display: 'flex', alignItems: 'center' }}>
          <div style={{ width: 6, height: 6, borderRadius: 10, backgroundColor: active ? '#ff8a06' : 'white' }} />
        </div>
        <div style={{ fontFamily: 'NSCJKrB', fontWeight: 'bold', fontSize: fontSize, color: active ? '#ff8a06' : 'black' }}>{children}</div>
      </div>
    </>
  );
};

export const ItemButton = ({ active = false, onClick, children }) => {
  return (
    <>
      <div onClick={onClick} style={{ display: 'flex', alignItems: 'center', height: 40, cursor: 'pointer' }}>
        <div style={{ width: 17, display: 'flex', alignItems: 'center' }}>
          <div style={{ width: 6, height: 6, borderRadius: 10, backgroundColor: active ? '#ff8a06' : 'white' }} />
        </div>
        <div style={{ fontFamily: active ? 'NSCJKrB' : 'NSCJKrR', fontSize: 17, color: active ? '#ff8a06' : 'black' }}>
          {children}
        </div>
      </div>
    </>
  );
};


export const CreditPlanChangeModal = ({ modalState, closeFunction, conformFunction, t }) => {
  console.log('!!!!!!!!!!!!!!!!!!!!!!!!');
  return (
    <Modal
      style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
      open={modalState}
      onClose={closeFunction}
    >
      <Fade in={modalState}>
          <ModalContents  onClose={closeFunction}>
              <ModalTitle>{t('refund_application')}</ModalTitle>
              <HSLine bgcolor="#eeeeee" />
              <VerticalSp sp={'1.5vw'} style={{ maxHeight: 28, minHeight: 14 }} />
            
          </ModalContents>
      </Fade>
    </Modal>
  );
};


export const TitleBlock = ({ title, children, style }) => {
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          height: '4.3vw',
          maxHeight: 78,
          minHeight: 40,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', ...style }}>
          <MediaQuery min={900}>
            <div style={{ fontFamily: 'NSCJKrB', fontSize: 30, color: 'black' }}>{title}</div>
          </MediaQuery>
          <MediaQuery  min={600} max={899}>
            <div style={{ fontFamily: 'NSCJKrB', fontSize: 22, color: 'black' }}>{title}</div>
          </MediaQuery>
          <MediaQuery  max={599}>
            <div style={{ fontFamily: 'NSCJKrB', fontSize: '5vw', color: 'black', }}>{title}</div>
          </MediaQuery>
          {children}
        </div>
      </div>
    </>
  );
};

export const LogOutBtn = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <>
      <div
        onClick={onClick}
        style={{
          cursor: 'pointer',
          borderRadius: 5,
          border: '1px solid #cccccc',
          fontFamily: 'NSCJKrR',
          fontSize: 14,
          display: 'flex',
          color: 'black',
          alignItems: 'center',
          justifyContent: 'center',
          width: 78,
          height: 30,
        }}
      >
        {t('sign_out')}
      </div>
    </>
  );
};

export const InfoLabel = styled.div`
  font-family: 'NSCJKrM';
  font-size: 16px;
  color: black;
`;

export const ImgSpecLbl = styled.div`
  font-family: 'NSCJKrR';
  font-size: 14px;
  color: #999999;
`;

export const SaveButton = styled.div`
  border-radius: 5px;
  background-color: #ff8a06;
  color: white;
  font-family: 'NSCJKrB';
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 50px;
`;

export const SignOutBtn = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <>
      <div onClick={onClick} style={{ cursor: 'pointer', display: 'flex', justifyContent: 'center' }}>
        <div
          style={{
            fontFamily: 'NSCJKrR',
            fontSize: 18,
            color: 'black',
            width: Store.get('lang') === 'kr' ? 100 : 220,
            height: 40,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
          }}
        >
          {t('deactivate_your_account')}
          <div style={{ position: 'absolute', bottom: 0, width: '100%', height: 2, backgroundColor: '#a9a9a9' }} />
        </div>
      </div>
    </>
  );
};

export const BlockHead = ({ children }) => {
  return (
    <>
      <MediaQuery min={900}>
        <div style={{ fontFamily: 'NSCJKrB', fontSize: 24, color: 'black', textAlign: 'center' }}>{children}</div>
      </MediaQuery>
      <MediaQuery max={899}>
        <div style={{ fontFamily: 'NSCJKrB', fontSize: 18, color: 'black', textAlign: 'center' }}>{children}</div>
      </MediaQuery>
    </>
  );
};

export const BlockHeadDes = ({ children }) => {
  return (
    <>
      <MediaQuery min={900}>
        <div
          style={{ fontFamily: 'NSCJKrR', fontSize: 16, color: '#666666', textAlign: 'center', wordBreak: 'keep-all' }}
        >
          {children}
        </div>
      </MediaQuery>
      <MediaQuery max={899}>
        <div
          style={{ fontFamily: 'NSCJKrR', fontSize: 'clamp(13px, 1rem + 1.2vw, 16px)', color: '#666666', textAlign: 'center' }}
        >
          {children}
        </div>
      </MediaQuery>
    </>
  );
};

export const RadioOption = ({ value, title, onClick }) => {
  return (
    <div
      onClick={onClick}
      style={{
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        fontFamily: 'NSCJKrM',
        fontSize: 16,
        color: 'black',
        lineHeight: 20,
        height: 20,
      }}
    >
      <img alt="" src={value ? images.icon_license_act : images.icon_license_nor} style={{ marginRight: 6 }} />
      {title}
    </div>
  );
};

export const UploadBtn = ({ onClick }) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={onClick}
      style={{
        fontFamily: 'NSCJKrB',
        fontSize: 18,
        color: 'white',
        cursor: 'pointer',
        backgroundColor: '#ff8a06',
        borderRadius: 5,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 50,
        width: 200,
      }}
    >
      <img alt="" src={images.icon_upload} style={{ marginRight: 6 }} />
      {t('upload')}
    </div>
  );
};

export const PortfolioArea = ({ children, style }) => {
  return (
    <div
      style={{
        borderRadius: 5,
        border: '1px dashed #c0c0c0',
        width: '100%',
        minHeight: 300,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        ...style,
      }}
    >
      <VerticalSp sp={'1.5vw'} style={{ maxHeight: 28, minHeight: 14 }} />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {/* <HorizontalSp sp={'1.4vw'} style={{ maxWidth: 26, minWidth: 13 }} /> */}
        <div
          style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
        >
          {children}
        </div>
        {/* <HorizontalSp sp={'1.4vw'} style={{ maxWidth: 26, minWidth: 13 }} /> */}
      </div>
      <VerticalSp sp={'1.5vw'} style={{ maxHeight: 28, minHeight: 14 }} />
    </div>
  );
};

export const PortfolioDes = styled.div`
  font-family: 'NSCJKrR';
  font-size: clamp(10px, 1rem + 1.2vw, 14px);
  color: #666666;
  text-align: center;
  // word-break: keep-all;
`;

export const NewPortfolio = ({ onClick }) => {
  return (
    <Ratio
      ratio={1}
      onClick={onClick}
      style={{
        cursor: 'pointer',
        width: 'calc(20% - 5px)',
        borderRadius: 5,
        backgroundImage: `url(${images.icon_upload})`,
        backgroundPosition: 'center',
        backgroundSize: 'initial',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#cccccc',
        position: 'relative',
        marginBottom: 5,
        marginRight: 5,
      }}
    />
  );
};

export const PortfolioItem = ({ onView, onRemove, vimg, seller_account_status }) => {
  return (
    <Ratio
      ratio={1}
      onClick={onView}
      style={{
        cursor: 'pointer',
        width: 'calc(20% - 5px)',
        borderRadius: 5,
        backgroundImage: seller_account_status === 0 ? `url(${vimg})` : `url(${process.env.REACT_APP_S3_BUCKET_DOMAIN}${vimg})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#cccccc',
        position: 'relative',
        marginBottom: 5,
        marginRight: 5,
      }}
    >
      <div onClick={onRemove} style={{ cursor: 'pointer', position: 'absolute', right: 5, top: 5 }}>
        <img alt="" src={`${images.icon_close_sm}`} />
      </div>
    </Ratio>
  );
};

export const AttentionArea = ({ children }) => {
  return (
    <div
      style={{
        borderRadius: 5,
        backgroundColor: '#fff4f3',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      }}
    >
      <VerticalSp sp={'1.5vw'} style={{ maxHeight: 28, minHeight: 14 }} />
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <HorizontalSp sp={'2.5vw'} style={{ maxWidth: 40, minWidth: 27 }} />
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>{children}</div>
        <HorizontalSp sp={'1.4vw'} style={{ maxWidth: 26, minWidth: 13 }} />
      </div>
      <VerticalSp sp={'1.5vw'} style={{ maxHeight: 28, minHeight: 14 }} />
    </div>
  );
};

export const AttentionLine = ({ children }) => {
  return (
    <>
      <div
        style={{
          fontFamily: 'NSCJKrR',
          fontSize: 'clamp(14px, 1rem + 1.2vw, 16px)',
          color: '#666666',
          lineHeight: '20px',
          // wordBreak: 'keep-all',
          textIndent: -14,
        }}
      >
        {children}
      </div>
    </>
  );
};
